import { Component, input, model, output } from '@angular/core';
import { Tone } from './tone';

// A toggle in the joined button bar, such as "Unhealthy 3".
export interface FilterChip {
  key: string;
  label: string;
  count: number;
  pressed: boolean;
  tone: Tone;
}

export interface FilterSelect {
  id: string;
  label: string;
  value: string;
  options: { value: string; label: string }[];
  // Lets a page style or find one select among several.
  className?: string;
}

export interface ViewOption {
  value: string;
  label: string;
}

// Search, toggle buttons, selects and an optional view switch, with the count of what is shown.
// The page owns every value; this only shows them and reports what the reader did.
@Component({
  selector: 'app-filter-bar',
  templateUrl: './filter-bar.html',
  styleUrl: './filter-bar.css',
})
export class FilterBar {
  readonly searchLabel = input.required<string>();
  readonly chips = input.required<FilterChip[]>();
  // What "All" counts: everything that matches the search, before the buttons narrow it.
  readonly allCount = input.required<number>();
  readonly allPressed = input.required<boolean>();
  readonly selects = input<FilterSelect[]>([]);
  readonly views = input<ViewOption[]>([]);
  readonly view = input('');
  readonly shown = input.required<number>();
  readonly total = input.required<number>();
  readonly hasFilter = input.required<boolean>();
  // Only set while the page header with the overall summary is scrolled out of view.
  readonly compactSummary = input<{ tone: string; headline: string } | null>(null);

  readonly query = model.required<string>();

  readonly toggleChip = output<string>();
  readonly clearChips = output<void>();
  readonly clearAll = output<void>();
  readonly selectChange = output<{ id: string; value: string }>();
  readonly viewChange = output<string>();

  protected setQuery(event: Event): void {
    this.query.set((event.target as HTMLInputElement).value);
  }

  protected onSelect(id: string, event: Event): void {
    this.selectChange.emit({ id, value: (event.target as HTMLSelectElement).value });
  }
}
